<script>
import attributesEs from "vee-validate/dist/locale/es";
import attributesEn from "vee-validate/dist/locale/en";
import VeeValidate, { Validator } from "vee-validate";

export default {
  created: function () {
    let locale = window.locale;
    Validator.localize(locale, locale == "en" ? attributesEn : attributesEs);

    Vue.use(VeeValidate, {
      locale: locale,
      dictionary: {
        translationsEn: { attributes: attributesEn },
        translationsEs: { attributes: attributesEs },
      },
      config: {
        aria: true,
        classNames: {},
        classes: false,
        delay: 0,
        dictionary: null,
        errorBagName: "errors", // change if property conflicts
        events: "blur",
        fieldsBagName: "fields",
        i18n: null, // the vue-i18n plugin instance
        i18nRootKey: "validations", // the nested key under which the validation messages will be located
        inject: true,
        validity: false,
        useConstraintAttrs: true,
      },
    });
  },
};
</script>
